import { DoctorProfile } from '@cureskin/api-client-rn';

export enum WeeklyJourneyType {
  WEEK_ZERO = 'WEEK_ZERO',
  WEEK_ONE_PART_ONE = 'WEEK_ONE_PART_ONE',
  WEEK_ONE_PART_TWO = 'WEEK_ONE_PART_TWO',
  WEEK_TWO_PART_ONE = 'WEEK_TWO_PART_ONE',
  WEEK_TWO_PART_TWO = 'WEEK_TWO_PART_TWO',
  WEEK_THREE = 'WEEK_THREE',
  WEEK_FOUR = 'WEEK_FOUR'
}

export interface WeeklyJourneyData {
  type: WeeklyJourneyType;
  user: any;
  latestPlacedRegimenOrder?: any;
  allocatedDoctor?: DoctorProfile;
  defaultDoctorImage?: string;
  primaryConcern?: string;
  otherConcerns?: string;
  pendingCheckInCall?: any;
  faceRegimenOrderDelivered?: any;
  latestFaceRegimenDelivered?: any;
  followUp?: any;
  weeklyJourneyVariant?: {
    variant2?: boolean;
    weekVisibility?: {
      week0: boolean;
      week1: boolean;
      week2: boolean;
      week3: boolean;
      week4: boolean;
    };
  }
}
